import { addToListModalStyles } from "@insite/content-library/Components/AddToListModal";
import { css } from "styled-components";

addToListModalStyles.listsSelect = {
    cssOverrides: {
        formField: css`
            margin-top: 15px;
        `,
        list:css`
            background: #ffffff;
        `,

    },
}

addToListModalStyles.addButton = {
    mergeCss:true,
    css: css`
        margin-left: 10px;
    `,
}